import React from 'react';
import { object, number } from 'prop-types';

const TabPanel = ({ children, value, index }) => {
  return value === index && <>{children}</>;
};

TabPanel.propTypes = {
  children: object.isRequired,
  index: number.isRequired,
  value: number.isRequired,
};

export default TabPanel;
